<template>
  <div class="loggedin">
    {{ $t("Logged In") }}
  </div>
</template>

<script>
import * as fbauth from "@/utils/firebase";
import { mapState } from "vuex";

export default {
  name: "Loggedin",

  components: {},

  data() {
    return {
      title: "",
      text: "",
      url: "",
    };
  },

  computed: {
    ...mapState("userData", ["loggedIn", "user", "userData"]),
    ...mapState("mail", ["mailToBeSent", "mailData"]),
  },

  methods: {
    forwardSend() {
      this.$router.push({
        path: "share-target",
        query: {
          title: this.title,
          text: this.text,
          url: this.url,
          send: "true",
        },
      });
    },
  },

  mounted() {
    this.title = this.$route.query.title || "";
    this.text = this.$route.query.text || "";
    this.url = this.$route.query.url || "";

    let urlMailData = {
      title: this.title,
      text: this.text,
      url: this.url,
    };

    this.$store.commit(
      "mail/mailToBeSentMutation",
      this.$route.query.mailToBeSent || false
    );
    this.$store.commit("mail/mailDataMutation", urlMailData);

    if (this.mailToBeSent) {
      this.forwardSend();
    }
  },
};
</script>
